import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import {
  ApplicationInsights,
  type BaseTelemetryPlugin,
} from '@microsoft/applicationinsights-web';
import { createBrowserHistory } from 'history';
import { ClientConfig } from '#/client-config';

// Only create browser history and initialize App Insights in browser environment
const isBrowser =
  typeof window !== 'undefined' && typeof document !== 'undefined';

const browserHistory = isBrowser ? createBrowserHistory() : null;
const appInsightsPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
  config: {
    connectionString: ClientConfig.applicationInsightsConnectionString,
    extensions: [appInsightsPlugin satisfies BaseTelemetryPlugin],
    extensionConfig: {
      [appInsightsPlugin.identifier]: { history: browserHistory },
    },
    // disabled to prevent back/forward cache from being blocked
    disablePageUnloadEvents: ['unload', 'beforeunload'],
  },
});

if (isBrowser && !import.meta.env.DEV) {
  appInsights.loadAppInsights();
  appInsights.trackPageView();
}

export { appInsights, appInsightsPlugin };
